//  0 = sms, 1 = auth app, 2 = email, 3 = none
export enum AUTH_MODE {
  SMS = 0,
  AUTH_APP = 1,
  EMAIL = 2,
  NONE = 3,
}
